import React from 'react';
import ProgressBar from '../../progress.bar';
import Footer from '../../Footer/footer';
import 'details-polyfill';
import { getCampaignDefaults } from '../../../selectors';
import { connect } from 'react-redux';

export const CustomerJourney = ({ campaignDefaults }) => {

  const clickOnCheckYourRate = () => document.getElementById('invitationCode').focus();
  const bankName = 'Barclays';

  return (
    <div id="customer-journey">
      <section className="the-journey">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <small className="text-uppercase headline-small">The journey</small>
              <h2 className="blue-text text-darken-4">
                Three simple steps to get you
                <br/>
                <strong>
                  closer to the money you need
                </strong>
              </h2>
            </div>
          </div>
          <div className="row text-center">
            <div className="col-12 d-none d-sm-block">
              <ProgressBar step="fullApp"/>
            </div>
          </div>

          <div className="row progressbar-description text-center grey-text">
            <div className="col-12 col-sm-4 description-card">
              <div className="small-progressbar">1. Check your rate</div>
              Lock in your APR up front.
            </div>
            <div className="col-12 col-sm-4 description-card">
              <div className="small-progressbar">2. Select your loan term</div>
              Choose your loan term to receive your guaranteed rate.
              Your approved loan amount and monthly payment will
              be determined upon review of your application

            </div>
            <div className="col-12 col-sm-4 description-card">
              <div className="small-progressbar">3. Apply for loan</div>
              Funds will be disbursed in a few
              business days upon loan offer
              acceptance.
            </div>
          </div>

          <div className="row text-center">
            <div className="col-12">
              <button name="checkYourRateButton" className="text-uppercase" data-track="getstrd-C" onClick={clickOnCheckYourRate}>
                Check your rate
              </button>
              <p className="grey-text impact-message">
                <i className="material-icons">thumb_up</i> Checking your rate won't affect your credit score
              </p>
            </div>

          </div>
        </div>
      </section>
      <section className="rates">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6">
              <div className="content">
                <small className="grey-text headline-small">OUR RATES</small>
                <h2 className="blue-text text-darken-4">
                  Competitively low rates keep
                  <br />
                  <strong>
                    more money in your pocket
                  </strong>
                </h2>
                <p className="grey-text">
                  Stop putting your dollars toward interest, and start saving!
                </p>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6">
              <div className="card z-depth-5 text-center">
                <div>
                  <p className="grey-text">APRs range from</p>
                  <h3 className="blue-text text-darken-4">
                    <strong>{campaignDefaults.minApr}%</strong> - <strong>{campaignDefaults.maxApr}%</strong>
                  </h3>
                  <button data-track="checkrate-M" className="text-uppercase" onClick={clickOnCheckYourRate}>
                    Check your rate
                  </button>
                  <div>
                    <p className="grey-text impact-message">
                      <i className="material-icons">thumb_up</i> Checking your rate won't affect your credit score
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="example">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="content">
                <small className="grey-text text-uppercase headline-small">Example</small>
                <h2 className="blue-text text-darken-4">
                  A versatile loan that
                  <br />
                  <strong>
                    puts you in control
                  </strong>
                </h2>
                <p className="grey-text">
                  Manage your loan with a fixed, monthly payment.
                </p>
              </div>
            </div>
          </div>
          <div className="row text-center blue-text darken-4">
            <div className="col-12 col-sm-3">
              <h3><strong>$10,000</strong></h3>
              <p className="grey-text">Loan amount</p>
            </div>
            <div className="col-12 col-sm-1">
              <h3>@</h3></div>
            <div className="col-12 col-sm-3">
              <h3><strong>5.99%</strong></h3>
              <p className="grey-text">APR</p>
            </div>
            <div className="col-12 col-sm-1">
              <h3>=</h3></div>
            <div className="col-12 col-sm-3">
              <h3><strong>$236</strong></h3>
              <p className="grey-text required">Monthly payment <br /> over 48 months
              </p>
            </div>
          </div>
          <div className="row">
            <p className="grey-text col-12 col-md-8 offset-md-2 disclosure prefix-asterisk">The above example is for
              illustration
              purpose only.
              Barclays Bank Delaware ({ bankName }) offers loans from $5,000 – $35,000 with flexible terms of 36, 48,
              and
              60 months and APRs ranging from {campaignDefaults.minApr}% – {campaignDefaults.maxApr}%. Your approved loan amount and
              APR will be based on your creditworthiness and length of term requested.</p>
          </div>
        </div>
      </section>
      <div id="max-float">
        <section className="benefits">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="content">
                  <small className="grey-text headline-small">LOAN BENEFITS</small>
                  <h2 className="blue-text text-darken-4">
                    The perfect combination
                    <br />
                    <strong>
                      to help you achieve your goals
                    </strong>
                  </h2>
                  <p className="grey-text">
                    Flexible terms put you in control.
                  </p>
                </div>
              </div>
            </div>
            <div className="row blue-text darken-4">
              <div className="col-12 col-md-4">
                <div className="card z-depth-5">
                  <h3>$0 in fees</h3>
                  <p className="grey-text">With a { bankName } Personal Loan, you'll pay no fees of any kind.</p>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="card z-depth-5">
                  <h3>Quick rate check</h3>
                  <p className="grey-text">Checking your rate won't affect your credit score.</p>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="card z-depth-5">
                  <h3>Flexibility</h3>
                  <p className="grey-text">Choose your payment due date or pay off your loan early.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="faqs">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="content">
                  <h4 className="blue-text text-darken-4 ">
                    { bankName } <strong>&amp; you</strong>
                  </h4>
                  <p className="grey-text col-12 col-md-8">
                    When our founders created { bankName }, they set out with the goal to make it easier for you to reach
                    your financial goals. We view our products as a way for you to succeed. Serving 36 million customers
                    around the world, we make sure to value every single
                    customer relationship. That's how we can keep our promise to never lose sight of where we came from
                    and
                    why we're here.
                  </p>
                </div>
              </div>
            </div>
            <br />
            <br />
            <br />

            <div className="row">
              <div className="col-12">
                <h5 className="blue-text text-darken-3">{ bankName } Personal Loan Q&amp;A</h5>
                <br />
                <br />

                <div className="card z-depth-5" id="faq">
                  <details>
                    <summary role="button" aria-expanded="false" tabIndex="0" className="blue-text text-darken-3">
                      Overview<i className="material-icons blue-text text-darken-3">add</i></summary>
                    <h4>What is a personal loan?</h4>
                    <p>Personal loans are offered to individual borrowers who demonstrate a proven ability to manage
                      credit.
                      These loans are unsecured, meaning they don’t require collateral such as a home or a car. Most
                      often,
                      personal loans are used to consolidate debt, to pay for a life event such as a wedding or a
                      once‐in‐a‐
                      lifetime vacation, or to finance a major purchase.</p>
                    <h4>How much money can I borrow?</h4>
                    <p>With a { bankName } Personal Loan, qualified applicants can borrow any amount from $5,000 to
                      $35,000,
                      with a payoff term of 36, 48 or 60 months.</p>
                    <h4>What is the APR?</h4>
                    <p>The annual percentage rates (APR) offered on our personal loans currently range from {campaignDefaults.minApr}% to {campaignDefaults.maxApr}%,
                      depending on the borrower's credit history. These rates are fixed and do not vary with changes in
                      the prime rate.</p>
                    <h4>How long does the application process take?</h4>
                    <p>You can apply online in just a few minutes. If you provide all the necessary information, we may
                      be able
                      to give you a decision that same day, although most loan applications will take a few days to
                      complete.</p>
                    <h4>Are there any fees for applying?</h4>
                    <p>No. There are no loan origination fees – or fees of any kind – on the { bankName } Personal Loan
                      product.</p>
                    <h4>When can I receive the funds?</h4>
                    <p>After you’ve been approved for a { bankName } Personal Loan, you’ll receive your funds in a few
                      business
                      days. </p>
                  </details>
                  <details>
                    <summary role="button" aria-expanded="false" tabIndex="0" className="blue-text text-darken-3">
                      Application process<i className="material-icons blue-text text-darken-3">add</i></summary>
                    <h4>How do I apply?</h4>
                    <p>Just click Check your rate and follow the prompts. Then choose the term/APR that meets your
                      needs.
                      Our 100% online application process will help you track the progress of your application, upload
                      your
                      information and documents, and receive updates about the progress of your application over the
                      web.</p>
                    <h4>Will checking my rate affect my credit score?</h4>
                    <p>No. Checking your rate will not affect your credit score. We simply use a “soft” credit inquiry
                      to gauge
                      your creditworthiness. This is not reported to creditors or the credit reporting agencies.</p>
                    <h4>Will you check my credit score when I actually apply?</h4>
                    <p>Yes, but only after you submit your application – not when you are checking your rate. Your
                      credit score
                      and other information in your credit history will help us determine your creditworthiness.</p>
                    <h4>What information do you need from me?</h4>
                    <p>Your name, address, contact information, Social Security number, and your employment and
                      financial
                      background. Be sure to have your information handy before you fill out our online application.</p>
                    <h4>Do I have to put up collateral for a { bankName } Personal Loan?</h4>
                    <p>No. The { bankName } Personal Loan is unsecured – meaning that you don’t need collateral. You
                      qualify for
                      a loan based on your credit history, income and other factors.</p>
                    <h4>Do I need to send you any written documentation?</h4>
                    <p>We will need certain documents to evaluate your loan application. You can upload them through our
                      secure Application Center, which supports the following file formats: .pdf, .doc, .jpg, .gif, .png
                      and .bmp.</p>
                    <h4>Will you tell me which documents you want me to upload?</h4>
                    <p>Yes. We’ll let you know in a message sent through our secure Application Center.</p>
                    <h4>What if I decide to cancel my loan application after I submit it?</h4>
                    <p>You may cancel your loan application any time before you sign for it electronically.</p>
                    <h4>Will you share my personal information with anyone?</h4>
                    <p>No. We won’t share your personal information, but we will use it to check your credit
                      history.</p>
                  </details>
                  <details>
                    <summary role="button" aria-expanded="false" tabIndex="0" className="blue-text text-darken-3">
                      Receiving your loan<i className="material-icons blue-text text-darken-3">add</i></summary>
                    <h4>How long will it take to get my loan?</h4>
                    <p>{ bankName } will distribute the funds in a few business days. Delays
                      may occur based on your financial institution’s policies and procedures.</p>
                    <h4>Can I choose how to receive my funds?</h4>
                    <p>Yes. You can have your funds deposited into a U.S. checking or savings account, or you can have
                      us pay
                      off up to 5 credit card balances directly.</p>
                  </details>
                  <details>
                    <summary role="button" aria-expanded="false" tabIndex="0" className="blue-text text-darken-3">
                      Making payments<i className="material-icons blue-text text-darken-3">add</i></summary>
                    <h4>Will I receive account statements each month?</h4>
                    <p>No. There are no paper statements for the { bankName } Personal Loan. You can view your payment
                      and
                      transaction history through our secure customer service website.</p>
                    <h4>How do I make payments on my loan?</h4>
                    <p>You’ll pay online through our secure customer service website. You can set up automatic repeat
                      payments, or you can log in each month and pay us electronically.</p>
                    <h4>Can I set up automatic repeat payments?</h4>
                    <p>Absolutely! Just sign up for automatic repeat payments, at no extra charge, and we’ll
                      automatically
                      deduct your payment from the U.S. checking or savings account that you’ve designated. Want to pay
                      off
                      your loan faster? Just pay more than the amount due each month.</p>
                    <h4>Can I change my payment due date?</h4>
                    <p>Yes. Once you’re approved for a { bankName } Personal Loan, you can select a due date different
                      from the
                      one we’ve given you. Please remember that changing your payment due date can affect your monthly
                      payment amount and/or your final loan payment amount.</p>
                    <h4>What if I’m late with a payment?</h4>
                    <p>If you don’t make your monthly payment on time, your loan balance will continue to accrue
                      interest,
                      which could affect your total loan repayment amount. There are no late fees for missing your
                      payment
                      due date. We’ll send you email notifications when your payments are due. We’ll also email you if
                      you’ve
                      missed a payment.</p>
                    <h4>Can I pay my loan off early, without penalty?</h4>
                    <p>Yes. There are no prepayment penalties. You can pay your loan off faster by making larger
                      payments or
                      extra payments each month.</p>
                  </details>
                  <details>
                    <summary role="button" aria-expanded="false" tabIndex="0" className="blue-text text-darken-3">
                      Online Servicing<i className="material-icons blue-text text-darken-3">add</i></summary>
                    <h4>Can I manage my loan account online?</h4>
                    <p>Yes. Just log in to our secure customer website to check your balance, make payments, set up
                      automatic
                      repeat payments, and more.</p>
                    <h4>Can I access my loan account from my cell phone?</h4>
                    <p>Yes. You can access our website through your mobile device.</p>
                    <h4>What if I forget my online password?</h4>
                    <p>Click the Forgot Password link to regain access to our secure customer website.</p>
                  </details>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer/>
        <div className="text-center floating-footer  blue darken-4 " id="floating-footer">
          <button data-track="checkrate-B" onClick={clickOnCheckYourRate}>
            Check your rate
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  campaignDefaults: getCampaignDefaults(state)
});

export default connect(mapStateToProps)(CustomerJourney);
